/**
 * Carrega os dados públicos usados pelas páginas do site: planos, informações
 * da plataforma e depoimentos publicados.
 */

import { useContext, useEffect, useState } from 'react';
import {
  getPublishedTestimonials,
  Testimonial,
  getPublicPlans,
  getPlatformInfo,
  PublicPlatformInfo,
  SubscriptionPlan,
} from '@services/platformService';
import { FALLBACK_PLANS } from './content';
import { PrerenderDataContext } from './prerenderData';

export function usePlatformData() {
  const prerendered = useContext(PrerenderDataContext);
  const [plans, setPlans] = useState<SubscriptionPlan[]>(prerendered?.plans ?? []);
  const [plansLoading, setPlansLoading] = useState(!prerendered);
  const [platform, setPlatform] = useState<PublicPlatformInfo | null>(null);
  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);

  useEffect(() => {
    let cancelled = false;
    getPublicPlans()
      .then(data => {
        if (!cancelled) setPlans(data.length > 0 ? data : FALLBACK_PLANS);
      })
      .catch(() => {
        // API indisponível: exibe os planos de referência para não deixar a seção vazia
        if (!cancelled) setPlans(FALLBACK_PLANS);
      })
      .finally(() => {
        if (!cancelled) setPlansLoading(false);
      });
    getPublishedTestimonials()
      .then(data => {
        if (!cancelled) setTestimonials(data);
      })
      .catch(() => undefined);
    getPlatformInfo()
      .then(data => {
        if (!cancelled) setPlatform(data);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  const trialDays = plans.find(p => p.isTrial)?.trialDays || platform?.defaultTrialDays || 30;

  return { plans, plansLoading, platform, testimonials, trialDays };
}
